import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { blockContent } from "../../page-content/commercial-content/blockContent";

const BlockManagement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={blockContent} />
      <Intro data={blockContent} />
      <ContentLeft data={blockContent} />
      <ContentRight data={blockContent} />
      <CallToAction data={blockContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default BlockManagement;
